import { useTranslation } from 'react-i18next';
import services from '../../data/services';
import Card from '../Card';
import useInView from '../../hooks/useInView';
import useWindowSize from '../../hooks/useWindowSize';
import Carousel from 'react-multi-carousel';
import { responsiveCarousel } from '../../config/consts';

const Services = () => {
    const { t, i18n } = useTranslation();
    const [ref, isInView] = useInView();
    const windowSize = useWindowSize();

    const isRtl = i18n.language === 'he';
    const isLargeScreen = windowSize > 767;

    const renderServices = () => {
        return services.map((service) => (
            <Card
                key={service._id}
                icon={service.icon}
                name={t(service.name)}
                description={t(service.description)}
                isRtl={isRtl}
            />
        ));
    };

    return (
        <section id='services'>
            <div className='container-xxl' ref={ref}>
                <div className='text-center'>
                    <h3 className='section-title'>
                        <span className={`${isRtl ? 'text-primary' : 'text-secondary'}`}>
                            {t('services-title.part1')}
                        </span>
                        <span className={`${isRtl ? 'text-secondary' : 'text-primary'}`}>
                            {t('services-title.part2')}
                        </span>
                    </h3>
                </div>
                <div className={isInView ? 'fade-up' : ''}>
                    <Carousel
                        responsive={responsiveCarousel}
                        infinite={true}
                        showDots={!isLargeScreen}
                        draggable={!isLargeScreen}
                        removeArrowOnDeviceType={['mobile', 'tablet', 'desktop']}
                    >
                        {renderServices()}
                    </Carousel>
                </div>
            </div>
        </section>
    );
};

export default Services;
